module.exports = {"id":"201290","name":"Robert Žulj","rating":"72","photo":"./data/images/photos/0/201290.png","club":{"name":"1899 Hoffenheim","logo":"./data/images/clubs/1899Hoffenheim.png"},"positions":["ATT","MOC","BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RobertZulj0.json
// module id = 3636
// module chunks = 0